module.exports = __webpack_public_path__ + "563bb9e7fe4edae298a4d7e1bc2c85e5.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/client_comment.svg
// module id = jXVd
// module chunks = 1